import { message } from "antd";
import React from "react";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { Link, useNavigate } from "react-router-dom";

import { AuthActions } from "app/redux/actions";
import { LoadingSelectors } from "app/redux/reducers";
import { getAuthData } from "app/services/auth";
import AdvancedButton from "components/shared/AdvancedButton/AdvancedButton";
import AdvancedInput from "components/shared/AdvancedInput/AdvancedInput";

class LoginWithRecaptcha extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle: false,
      email: "",
      password: "",
    };
  }

  userAuth = async e => {
    e.preventDefault();

    const { authenticate, getMe, googleReCaptchaProps, navigate } = this.props;

    const { email, password } = this.state;

    if (!(email && password))
      return message.error(I18n.t("routes.login.errors.fields"));

    let recaptchaToken =
      await googleReCaptchaProps.executeRecaptcha("homepage");

    authenticate({ email, password, recaptchaToken }, () => {
      navigate("/userPartner");
      message.success(I18n.t("routes.login.messages.welcome"));
      getMe();
    });
  };

  render() {
    const { email, password } = this.state;
    const { loading } = this.props;

    return (
      <>
        <div className="app-login">
          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-xl-6 col-sm-12 order-xl-2">
                <div className="row align-items-center">
                  <div className="col no-pd">
                    <div className="app-login__banner">
                      <img
                        src="/assets/svg/overlay.svg"
                        className="img-fluid app-login__banner__content__overlay"
                        alt="overlay"
                      />
                      <div className="app-login__banner__content">
                        <div className="row justify-content-center">
                          <div className="col-lg-8 col-md-12 m-3">
                            <img
                              src="/assets/svg/cpfl-logo.svg"
                              className="img-fluid app-login__banner__content__logo"
                              alt="cpfl-logo"
                            />
                            <h1 className="app-login__banner__content__title mt-5">
                              {I18n.t("routes.login.content.title")}
                            </h1>
                            <h2 className="app-login__banner__content__sub-title">
                              {I18n.t("routes.login.content.subtitle")}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-sm-12 order-xl-1">
                <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-12 m-3">
                    <div className="position-relative">
                      <div className="app-login__block__header">
                        <div className="row">
                          <div className="col-12">
                            <h1 className="app-login__block__header__hello">
                              Parceiro - CPFL Total
                            </h1>
                            <p className="app-login__block__header__greetings">
                              Insira os dados abaixo para acessar o sistema.
                            </p>
                          </div>
                        </div>
                      </div>
                      <form onSubmit={e => this.userAuth(e)}>
                        <div className="row">
                          <div className="col-12">
                            <div className="app-login__block__field">
                              <AdvancedInput
                                disabled={loading && loading}
                                label="E-mail"
                                value={email}
                                onChange={value =>
                                  this.setState({ email: value })
                                }
                                tabIndex="1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <AdvancedInput
                              label={I18n.t(
                                "routes.login.content.passwordLabel"
                              )}
                              value={password}
                              disabled={loading && loading}
                              onChange={value =>
                                this.setState({ password: value })
                              }
                              isPassword
                              tabIndex="1"
                            />
                            <Link to={I18n.t("routes.passwordRecovery.url")}>
                              <p className="app-login__block__forgot">
                                {I18n.t("routes.login.content.forgetPassword")}
                              </p>
                            </Link>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <div className="app-login__block__button">
                              <AdvancedButton
                                center
                                submit
                                text={I18n.t(
                                  "routes.login.content.loginButton"
                                )}
                                disabled={loading && loading}
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const Login = withGoogleReCaptcha(LoginWithRecaptcha);

const mapStateToProps = state => ({
  loading: LoadingSelectors.getLoading(state),
});

const mapDispatchToProps = dispatch => ({
  authenticate: (user, callback) =>
    dispatch(AuthActions.authenticate(user, callback)),
  getMe: () => dispatch(AuthActions.getMe()),
});

const LoginWithNavigate = Component => {
  return props => {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginWithNavigate(Login));
